# [Common]
## Header
HeaderAccessToken:
  name: access_token
  in: header
  required: true
  description: アクセストークン
  schema:
    type: string

HeaderAuthCode:
  name: auth-code
  in: header
  required: true
  description: 認証に必要なAPIキー
  schema:
    type: string

## Query
QueryLanguage:
  name: lang
  in: query
  description: |
    クライアントが使用中の言語。応答の言語で使用されます。
  schema:
    $ref: './schemas/common.yaml#/Language'

QuerySSOKey:
  name: key
  in: query
  require: true
  description: アクセスキー
  schema:
    type: string
    example: VGVABCTi1rZmF4MS02ODU1Nw==

# [By Group]
## Admin
PathAdminSeq:
  in: path
  name: admin_seq
  description: リセラー固有キー
  required: true
  schema:
    type: string

## Auth
UserJauth:
  - in: form
    name: code
    description: 会社コード
    required: true
    schema:
      type: string
  - in: query
    name: id
    description: ID
    required: true
    schema:
      type: string
  - in: query
    name: password
    description: パスワード
    required: true
    schema:
      type: string
  - in: query
    name: otpPassword
    description: OTP (One Time Password)
    schema:
      type: string

## Company
PathCompanySeq:
  in: path
  name: company_seq
  description: 会社固有キー
  required: true
  schema:
    type: string

PathCompanyCode:
  in: path
  name: company_code
  description: 会社コード
  required: true
  schema:
    type: string

QueryCode:
  in: query
  name: code
  description: 会社コード
  required: true
  schema:
    type: string

QueryServiceKeyType:
  in: query
  name: type
  description: |
    サービスキータイプ
      - manager: 管理者向け
      - user: ユーザー向け
  schema:
    type: string
    default: manager
    enum:
      - manager
      - user

QueryServiceKeyAllType:
  in: query
  name: type
  description: |
    サービスキータイプ
      - **manager**: 管理者向け
      - **user**: ユーザー向け
      - **all**: 両方
  schema:
    type: string
    default: all
    enum:
      - manager
      - user
      - all

QueryKey:
  in: query
  name: key
  description: サービスキー
  schema:
    type: string

QueryKeyUser:
  in: query
  name: user_service_key
  description: |
    ユーザ向けのサービスキーの組み合わせ
    - 値を送信しないと、ランダムな組み合わせのユーザー用サービスキーが自動的に生成されます。
  schema:
    type: string

QueryKeyManager:
  in: query
  name: manager_service_key
  description: |
    管理者向けのサービスキーの組み合わせ
    - 値を渡さないと、ランダムな組合の管理者用サービスキーが自動的に生成されます。
  schema:
    type: string



QueryCompanyName:
  in: query
  name: name
  description: 照会する会社名(グループ名)
  schema:
    type: string

QueryCompanySort:
  in: query
  name: sort
  description: 照会する会社整列方法
  schema:
    type: string
    default: -company_seq
    enum:
      - company_seq
      - -company_seq
      - code
      - -code
      - name
      - -name
      - reseller_name
      - -reseller_name
      - license_amount
      - -license_amount

## File
PathFileSeq:
  in: path
  name: file_seq
  description: ファイル識別コード
  required: true
  schema:
    type: number

PathRead:
  in: path
  name: read
  description: 読みフラグ(`'Y'` or `'N'`)
  required: true
  schema:
    type: number

CompressedFileSeq:
  in: path
  name: file_seq
  description: ファイル識別コード
  required: true
  schema:
    type: string

CompressedFileSeqOptional:
  in: path
  name: file_seq
  description: ファイル識別コード
  required: false
  schema:
    type: string

## Folder
PathNode:
  in: path
  name: node
  description: フォルダノード
  required: true
  schema:
    type: string

PathNodeOptional: # TODO: Check => 어떻게 empty value 로 값을 보낼 수 있을 것인가.
  in: path
  name: node
  description: フォルダノード
#  allowEmptyValue: true
  schema:
    type: string
    nullable: true

PathDirSeq:
  in: path
  name: dir_seq
  description: フォルダ識別コード
  required: true
  schema:
    type: string

## Group
QueryGroupSeq:
  in: query
  name: group_seq
  description: グルーブ識別コード
  schema:
    type: number

QueryKeyword:
  in: query
  name: keyword
  description: ユーザーIDまたはユーザー名を検索するキーワード
  schema:
    type: string

PathGroupSeq:
  in: path
  name: group_seq
  description: グルーブ識別コード
  schema:
    type: string

PathGroupSeqRequired:
  in: path
  name: group_seq
  description: グルーブ識別コード
  required: true
  schema:
    type: string


## Item
PathItemCode:
  in: path
  name: item_code
  description: アイテムコード
  required: true
  schema:
    type: string
    enum:
    - freetrial
    - free
    - lite
    - basic_v2
    - standard
    - business
    - premium
    - enterprise

## Notice
PathNoticeSeq:
  in: path
  name: notice_seq
  description: お知らせ固有キー
  required: true
  schema:
    type: string

QueryNoticeTitle:
  in: query
  name: title
  description: 照会するお知らせのタイトル
  schema:
    type: string
    default:

QueryNoticeCategory:
  in: query
  name: category
  description: 照会するお知らせ事項区分
  schema:
    type: string
    enum:
      - NOTICE (お知らせ)
      - UPDATE (アップデート)
      - ISSUE (障害情報)
      - CORRECT (その他)
    default: ''

QueryNoticeStatus:
  in: query
  name: status
  description: 照会する公開/非公開お知らせ
  schema:
    type: string
    enum:
      - 0 (비공개)
      - 1 (공개)
    default: ''

QueryNoticeSort:
  in: query
  name: sort
  description: 照会するお知らせの並び替え方法
  schema:
    type: string
    default: -notice_seq
    enum:
      - +notice_seq
      - -notice_seq
      - +title
      - -title
      - +status
      - -status
      - +category
      - -category
      - +created
      - -created

## Query
QueryAdminSort:
  in: query
  name: sort
  description: 照会する管理者の並び替え方法
  schema:
    type: string
    default: admin_seq
    enum:
      - admin_seq
      - -admin_seq

QueryFileSort:
  in: query
  name: sort
  description: 照会するファイルの整列方法
  schema:
    type: string
    default: -name
    enum:
      - +name
      - -name
      - +datetime
      - -datetime
      - +size
      - -size

QueryLimit:
  in: query
  name: limit
  description: |
    一度に照会するファイル数
    - maximum: 1000  
      max以上の値転送時にエラーが発生します。
  schema:
    type: number
    default: 100
    maximum: 1000

QueryLimit50:
  in: query
  name: limit
  description: |
    一度に照会するファイル数

  schema:
    type: number
    default: 50

QueryOffset:
  in: query
  name: offset
  description: 2ページ以降に存在するファイルの数
  schema:
    type: number
    default: 0

## User
QueryUserRole:
  in: query
  name: role_name
  description: |
    ユーザーロール
    - SUPERUSER: 契約管理者
    - MANAGER: 一般管理者
    - USER: ユーザー
    - GUEST: ゲスト
  schema:
    type: string

QueryUserStatus:
  in: query
  name: status
  description: |
    ユーザーの状態
    - 11: 有効
    - 41: 無効
    - 51: アカウントロック
    - 42: 一時停止
    - 91: 削除
    - 92: 脱退
  enum:
    - 11
    - 41
    - 42
    - 51
    - 91
    - 92
  schema:
    type: number

QueryUserLimit:
  in: query
  name: limit
  description: 一度に照会するユーザー数
  schema:
    type: number
    default: 20

PathUserSeq:
  in: path
  name: user_seq
  description: ユーザー識別コード
  required: true
  schema:
    type: string
